module.exports = __webpack_public_path__ + "img/preview.fdf6b6a1.webp";